export enum GameFont {
    Default = "Delagothicone Regular"
}
